import repository from '@/repositories/repository'
const resource = 'consumers'
export default {
  index (params) {
    return repository.get(`${resource}`, { params })
  },
  store (data) {
    return repository.post(`${resource}`, data)
  },
  show (id) {
    return repository.get(`${resource}/${id}/show`)
  },
  storeIndexAll (storeId) {
    return repository.get(`${resource}/${storeId}/all`)
  },
  count (params) {
    return repository.get(`${resource}/count`, { params })
  },
  update ({ id, data }) {
    return repository.put(`${resource}/${id}`, data)
  },
  export () {
    return repository.get(`${resource}/export`)
  },
  import ({ data, columns, unique }) {
    return repository.post(`${resource}/import`, { data, columns, unique })
  },
  new (data) {
    return repository.post(`${resource}/new`, data)
  },
  findKey (data) {
    return repository.post(`${resource}/key`, { data })
  },
  findKey2 (storeId, params) {
    return repository.get(`${resource}/${storeId}/keys`, { params })
  },
  countExport () {
    return repository.get(`${resource}/export/count`)
  },
  noOverdueCount (params) {
    return repository.get(`${resource}/no-overdue/count`, { params })
  },
  overdueCount (params) {
    return repository.get(`${resource}/overdue/count`, { params })
  },
  noOverdue (params) {
    return repository.get(`${resource}/no-overdue`, { params })
  },
  overdue (params) {
    return repository.get(`${resource}/overdue`, { params })
  },
  combobox (params) {
    return repository.get(`${resource}/combobox`, { params })
  },
  /**
   * Description
   * @param {string} consumerId
   */
  summaryOfLoans (consumerId) {
    return repository.get(`${resource}/${consumerId}/loan-summary`)
  },
}
